import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import jwtDecode from 'jwt-decode';
import { SentryService } from './sentry.service';
export interface LoginResultDto{
  "email"?: string,
  "phoneNumber"?:string,
  "nationalId"?: string,
  "userRoleId"?: any,
  "userId"?: string,
  "token"?: string,
  "arabicName"?: string,
  "englishName"?: string,
  "isActivated"?: boolean,
  "isSuspended"?: boolean,
  "birthDate"?: Date,
  "gender"?: string,
  isCompleteProfile?: boolean,
  "refreshToken"?: string,
  "expiryTokenInMinutes"?: number,
  "moznUserStatus"?: string,
  "investorDegreeType"?: string,
  "hasProfessionalPendingRequest"?: boolean,
  "hasInstitutionalPendingRequest"?: boolean,
  "expiryTokenDate"?:Date
}
@Injectable({
  providedIn: 'root',
})

export class UserService {

  constructor(
    private router: Router,
    private http: HttpClient,
    private sentryService: SentryService
  ) { }
  private _currentUserCredantials?: LoginResultDto;

  get currentUserCredantials(): LoginResultDto {
    if (localStorage.getItem("currentUser")) {
      return JSON.parse(localStorage.getItem("currentUser") as string) as LoginResultDto;
    }
    else
      return undefined!;

  }
  set currentUserCredantials(value: LoginResultDto) {
    if(value && value.expiryTokenInMinutes)
    {
      var expiryDate = new Date();
      expiryDate.setMinutes(expiryDate.getMinutes() + value.expiryTokenInMinutes! - 5);
      value.expiryTokenDate = expiryDate;
    }
    this._currentUserCredantials = JSON.parse(JSON.stringify(value));
    localStorage.setItem("currentUser", JSON.stringify(this._currentUserCredantials));
    
    // Set Sentry user context when user credentials are updated
    if (value) {
      this.sentryService.setUserContext({
        userId: value.userId,
        email: value.email,
        userRoleId: value.userRoleId,
      });
    }
  }

  getCurrentSystemLanguage(): string {
    let language = localStorage.getItem('language');
    if (language) return language;
    else {
      localStorage.setItem('language', 'en-US');
      return 'en-US';
    }
  }
  setLanguage(language: string) {
    localStorage.setItem('language', language);
  }
  isLoggedIn(): boolean {
    let token = localStorage.getItem('token');
    let refreshToken = localStorage.getItem('refreshToken');
    if (token || refreshToken) return true;

    return false;
  }


  setToken(token: string) {
    localStorage.setItem('token', token);
    var decodedToken:any = jwtDecode(token);
    this.setRoles(decodedToken!.Roles)
  }

  setRoles(roles: string){
    localStorage.setItem('roles', roles);
  }

  getRoles(): string | null {
    return localStorage.getItem('roles');
  }

  setRefreshToken(token: string) {
    localStorage.setItem('refreshToken', token);
  }
  getToken(): string | null {
    return localStorage.getItem('token');
  }
  getRefreshToken(): string | null {
    return localStorage.getItem('refreshToken');
  }
  removeToken() {
    localStorage.removeItem('token');
  }
  removeRefreshToken() {
    localStorage.removeItem('refreshToken');
  }
  setVerificationEmail(email: string) {
    localStorage.setItem('verificationEmail', email);
  }

  getVerificationEmail(): string | null {
    return localStorage.getItem('verificationEmail');
  }
  logout() {
    // Clear Sentry user context on logout
    this.sentryService.clearUserContext();
    this.clearLocalStorage();
    this.router.navigate(['/authentication/login']).then(() => {
      window.location.reload();
    });
  }
  clearLocalStorage(){
    localStorage.clear();
    this.removeToken();
    this.removeRefreshToken();
  }
  setUserName(nameEn: string) {
    if (nameEn) {
      localStorage.setItem('userNameEn', nameEn);
    }
  }

  getUserName() {
    let name = localStorage.getItem('userNameEn');
    if (name) return name;
    return '';
  }
  getCanAdd(): any {
    let canAdd = localStorage.getItem('canAdd');
    if (canAdd) {
      return canAdd;
    }
  }

  setCanAdd(canAdd: any) {
    if (canAdd == null) {
      localStorage.removeItem(canAdd);
    } else {
      localStorage.setItem('canAdd', canAdd);
    }
  }

  setUserId(userId: string) {
    if (userId) {
      localStorage.setItem('userId', userId);
    }
  }

  getUserId() {
    let userId = localStorage.getItem('userId');
    if (userId) return userId;
    return '';
  }

  setSessionExpiryDate(expiryInMinutes: number) {
    var expiryDate = new Date();
    expiryDate.setMinutes(expiryDate.getMinutes() + expiryInMinutes - 5); // minus 5 minutes to handle paralel requests
    localStorage.setItem('expiry_date', expiryDate.getTime().toString());
  }

  getSessionExpiryDate() {
    return localStorage.getItem('expiry_date');
  }
}